/*import {Swiper, Navigation, Thumbs, Pagination, Autoplay} from 'swiper';*/
/*import {setSliderCirclesAnimation} from "../utils/animations";*/
import {loadLibrary, scrollToElement,getHashVar} from './Util';
import {LIB_URL} from '../App';

const $thumbSlider = $('.js-thumb-slider');

if ($thumbSlider.length) {
    loadLibrary(LIB_URL.SWIPER, () => {
        $thumbSlider.each(function (index, el) {
            let $currSlider = $(el);
            let $currSliderWrap = $currSlider.closest('.js-thumb-slider-wrap');
            let $currSliderText = $currSlider.siblings('.js-thumb-slider-text');
            let $currSliderTitle = $currSliderWrap.find('.js-thumb-slider-title');
            let autoplay = $currSlider.data('autoplay');

            if (autoplay != undefined) {
                autoplay = autoplay || 10;
            }

            $currSlider.addClass(`js-thumb-slider-${index}`);

            $currSlider.find('.js-thumb-slider-thumbs').addClass(`js-thumb-slider-thumbs-${index}`);
            $currSlider.find('.js-thumb-slider-top').addClass(`js-thumb-slider-top-${index}`);

            $currSliderWrap.find('.js-thumb-slider-prev-btn').addClass(`js-thumb-slider-prev-btn-${index}`);
            $currSliderWrap.find('.js-thumb-slider-next-btn').addClass(`js-thumb-slider-next-btn-${index}`);
            let thumbsOptions = {
                // /!*spaceBetween: 30,*!/
                spaceBetween: 20,
                slidesPerView: 2.5,
                freeMode: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                centeredSlides:true,
                centeredSlidesBounds:true,
                mousewheel: 'thumbMousewheel' in $currSlider.data() ? {
                    forceToAxis: true,
                    sensitivity: 4,
                    releaseOnEdges: false
                } : false,
                scrollbar: 'thumbScrollbar' in $currSlider.data() ? { el: '.swiper-scrollbar', draggable: true } : false,
                direction: (App.W.width() > 1023 && 'thumbVertical' in $currSlider.data()) ? 'vertical' : 'horizontal',
                breakpoints: {
                    430: {
                        spaceBetween: 15,
                        slidesPerView: 2
                    },
                    768: {
                        spaceBetween: 30,
                        slidesPerView: 3.5
                    },
                    1122: {
                        spaceBetween: 20,
                        slidesPerView: 3.8
                    },
                },
                on: {
                    slideChangeTransitionStart () {
                        $('.js-button-read-ginekology').css('opacity','0');
                    },
                    slideChangeTransitionEnd () {
                        $('.js-button-read-ginekology').css('opacity','1');
                    }
                },
            };

            const isGinekology = $currSliderWrap.is('.thumb-slider-wrap-ginekology--big');
            const isCardioTuesday = $currSliderWrap.is('.thumb-slider-wrap-cardio_tuesday--big');
            if (isGinekology) {
                thumbsOptions = Object.assign(thumbsOptions, {
                    slidesPerView: 2,
                    spaceBetween: 15,
                    freeMode: true,
                    autoHeight: true,
                    // breakpoints: {
                    //     768: {
                    //         slidesPerView: 3
                    //     },
                    //     1024: {
                    //         slidesPerView: 3
                    //     },
                    //     1200: {
                    //         slidesPerView: 3
                    //     },
                    //     1490: {
                    //         slidesPerView: 5
                    //     }
                    // },
                    on: {
                        init:function(){
                            setSlideHeight(this, $(`.js-thumb-slider-thumbs-${index}`));
                        },
                        slideChange () {
                            setSlideHeight(this, $(`.js-thumb-slider-thumbs-${index}`));
                            $currSliderWrap.closest('.js-tab-contents').css('min-height', '');
                        }
                    }
                });
            }
            if (isCardioTuesday) {
                thumbsOptions = Object.assign(thumbsOptions, {
                    slidesPerView: 2,
                    spaceBetween: 15,
                    freeMode: true,
                    autoHeight: true,
                    breakpoints: {
                        430: {
                            spaceBetween: 15,
                            slidesPerView: 2
                        },
                        768: {
                            spaceBetween: 30,
                            slidesPerView: 2
                        },
                        1122: {
                            spaceBetween: 30,
                            slidesPerView: 3
                        }
                    },
                    on: {
                        init:function(){
                            setSlideHeight(this, $(`.js-thumb-slider-thumbs-${index}`));
                        },
                        slideChange () {
                            setSlideHeight(this, $(`.js-thumb-slider-thumbs-${index}`));
                            $currSliderWrap.closest('.js-tab-contents').css('min-height', '');
                        }
                    }
                });
            }



            let galleryThumbs = new Swiper(`.js-thumb-slider-thumbs-${index}`, thumbsOptions);

            /*Swiper.use([Thumbs, Navigation, Pagination, Autoplay]);*/

            const isSimulateTouch = !($(`.js-thumb-slider-top-${index}`).closest('.thumb-slider-wrap-ginekology').length > 0) && !($(`.js-thumb-slider-top-${index}`).closest('.thumb-slider-wrap-cardio_tuesday').length > 0);
            let options = {
                spaceBetween: 10,
                simulateTouch: isSimulateTouch,
                navigation: {
                    nextEl: `.js-thumb-slider-next-btn-${index}`,
                    prevEl: `.js-thumb-slider-prev-btn-${index}`,
                },
                on: {
                    slideChange(swiper) {
                        const hashIndex = $currSlider.find(`.swiper-slide[data-id="${galleryTop.activeIndex}"]`).attr('id');
                        history.replaceState(null, null, '#' + hashIndex);
                        const prevSlideIframe = $($currSlider.find('.gallery-top .swiper-slide')[galleryTop.previousIndex]).find('.js-swiper-slide-iframe');
                        if (prevSlideIframe) {
                            prevSlideIframe.attr('src', prevSlideIframe.attr('src'));
                        }

                        animateThumbsLine(
                            $currSlider.find('.js-thumb-slider-thumbs'),
                            galleryTop.activeIndex,
                            thumbsOptions.direction
                        );
                        swiper.$el.trigger('slider:change');
                    }
                },
                thumbs: {
                    swiper: galleryThumbs
                }
            };

            if ($currSliderWrap.is('.thumb-slider-wrap--pagination')) {
                options = Object.assign(options, {
                    pagination: {
                        el: $currSliderWrap.find('.js-thumb-slider-pagination')[0],
                        bulletClass: 'slider__pagination-item',
                        bulletActiveClass: 'slider__pagination-item--active',
                        clickable: true,
                    }
                });
            }

            if (autoplay) {
                options = Object.assign(options, {
                    autoplay: {
                        delay: autoplay * 1000
                    },
                });
            }
            let galleryTop = new Swiper(`.js-thumb-slider-top-${index}`, options);

            let $currThumbsItems = $currSlider.find('.js-thumb-slider-thumbs').find('.swiper-slide');

            if ($currThumbsItems.length == 1) {
                $currSlider.find('.js-thumb-slider-thumbs').addClass('_hide-gallery');
            }

            $currThumbsItems.each(function (index, el) {
                $(el).attr('data-id', index);
            });

            $currThumbsItems.eq(0).addClass('_active');

            $currThumbsItems.on('click', function () {
                const currIndex = $(this).data('id');

                galleryTop.slideTo(currIndex);

                // связь табов и слайдера с превьюшками - клик по превьюшке
                if ($(this).closest('.js-thumb-slider').hasClass('js-thumbs-tabs')) {
                    $('.js-tabs-thumbs').find('.js-tab-title[data-index="' + currIndex + '"]').trigger('click');
                    scrollToElement($('.js-tabs-thumbs'));
                    return;
                }
            });

            galleryTop.on('slideChangeTransitionStart', function () {
                $currSliderWrap
                    .find('.js-thumb-slider-text-item').removeClass('_active')
                    .filter(`[data-thumb-index="${galleryTop.activeIndex}"]`).addClass('_active');
                $currSliderWrap
                    .find('.js-thumb-slider-title-item').removeClass('_active')
                    .filter(`[data-thumb-index="${galleryTop.activeIndex}"]`).addClass('_active');
            });

            $currSliderWrap.find('.js-thumb-slider-text-item').eq(0).addClass('_active');
            $currSliderTitle.find('.js-thumb-slider-title-item:first-child').addClass('_active');

            $currSliderText.css('height', thumbsSliderTextHeight($currSliderText) + 'px');

            App.W.on('resize', function () {
                if (App.W.outerWidth() < 1024) {
                    $currSliderText.css('height', thumbsSliderTextHeight($currSliderText) + 'px');
                }
                if ('thumbVertical' in $currSlider.data()) {
                    const ww = App.W.width();
                    const $el = $(galleryThumbs.$el);
                    if (App.W.outerWidth() < 1024) {
                        thumbsOptions.direction = 'horizontal';
                        galleryThumbs.changeDirection('horizontal', true);
                    } else {
                        thumbsOptions.direction = 'vertical';
                        galleryThumbs.changeDirection('vertical', true);
                    }
                    galleryThumbs.update();
                    'thumbScrollbar' in $currSlider.data() ? galleryThumbs.scrollbar.updateSize() : null;
                }
            });

            $currSliderWrap.on('click', function () {
                galleryTop.autoplay.stop();
            });

            if (autoplay) {
                let mouseOver = false;

                $currSliderWrap.on('mouseenter', () => {
                    mouseOver = true;
                    App.W.on('scroll', autoplayToggle);
                }).on('mouseleave', () => {
                    mouseOver = false;
                    App.W.one('scroll', autoplayToggle);
                });

                function autoplayToggle() {
                    if (mouseOver == false) {
                        App.W.off('scroll', autoplayToggle);
                        if (!galleryTop.autoplay.running) {
                            galleryTop.autoplay.start();
                        }
                    }
                }
            }

            // связь табов и слайдера с превьюшками - клик по табам
            if ($currSlider.hasClass('js-thumbs-tabs')) {
                $('.js-tabs-thumbs .js-tab-title').on('click', function() {
                    let currIndex = $(this).data('index');

                    galleryTop.slideTo(currIndex);
                });

                App.W.on('selectTabChanged', function(_, data) {
                    if (Object.hasOwn(data, 'index')) {
                        galleryTop.slideTo(data.index);
                    }
                });

                let hash = getHashVar();
                let $hashTabActive = $('.js-tabs-thumbs .js-tab-title').filter('[id="' + hash + '"], [href="#' + hash + '"]');

                if (!$hashTabActive.length && $('.js-tabs-thumbs').data('start')) {
                    let startFrom = $('.js-tabs-thumbs').data('start') - 1;
                    // переключаем активное видео в слайдере
                    galleryTop.slideTo(startFrom);
                }

                if ($hashTabActive.length) {
                    //galleryTop.slideTo($hashTabActive.index());
                    $hashTabActive.trigger('click');}
            }

            $currSlider.find('.js-thumb-slider-thumbs .swiper-slide[id]').each((i, el) => {
                const hash = getHashVar();

                if (hash === el.id) {
                    scrollToSlide(el.id);
                }

                App.D.on('click', `a[href="#${el.id}"]`, () => {
                    scrollToSlide(el.id);
                });
            });
        });
    });

    function setSlideHeight(el, elContainer){
        elContainer.find('.swiper-slide').css({height:'auto'});
        let currentSlide = el.activeIndex;
        let newHeight = $(el.slides[currentSlide]).height();
        elContainer.find('.swiper-slide').css({height: newHeight});
        el.update();
        // elContainer.find('.swiper-slide').each(function () {
        //     const newHeight = $(this).height();
        //     console.log(newHeight)
        //     $(this).css('height', newHeight);
        // });
        // el.updateSize();
        // el.update();
    }




    function scrollToSlide(id) {
        const $slide = $('#' + id);

        $slide.click();
        $slide.closest('.js-tabs').each((i, rootDom) => {
            $(rootDom).find(`.js-tab-title[data-index="${$slide.closest('.js-tab-content').data('index')}"]`).click();
        });
        scrollToElement($slide.closest('.js-thumb-slider').find('.js-thumb-slider-top'));
    }

    function animateThumbsLine(currSlider, currIndex, swipeDirection) {
        let $currSliderItems = currSlider.find('.swiper-slide');
        let $oneSlide = $currSliderItems.eq(0);
        let oneSlideWidth = $oneSlide.outerWidth() + parseInt($oneSlide.css('margin-right'));
        let currSlidePosition = (currIndex - 1) * oneSlideWidth;
        let currX = currSlidePosition - currSlider.outerWidth() / 2 + 1.5 * oneSlideWidth;

        if (currX < currSlider.outerWidth() / 6) {
            currX =  0;
        } else if (Math.abs(currX) > Math.abs(currSlider.outerWidth() - $currSliderItems.length * oneSlideWidth)) {
            currX =  Math.abs(currSlider.outerWidth() - $currSliderItems.length * oneSlideWidth);
            currX -= parseInt($oneSlide.css('margin-right'));
        }

        $currSliderItems.removeClass('_active').eq(currIndex).addClass('_active');
        if (swipeDirection === 'horizontal') {
            currSlider.find('.swiper-wrapper').css({
                transform: `translateX(${-currX}px)`
            });
        }

        // связь табов и слайдера с превьюшками - клик по стрелкам превью
        if (currSlider.closest('.js-thumb-slider').hasClass('js-thumbs-tabs')) {
            $('.js-tabs-thumbs').find('.js-tab-title[data-index="' + currIndex + '"]').trigger('click');

            // нужно запретить скролл к табам при загрузке страницы,
            // если изначально активный таб не первый - для гинекологики
            if ($('.js-tabs-thumbs').data('start')) {
                setTimeout(function() {
                    $('.js-tabs-thumbs').data('start', false);
                }, 300);
            } else {
                if (!$('.js-tabs-thumbs').attr('data-noscrolltab')) {
                    scrollToElement($('.js-tabs-thumbs'));
                }
            }
        }
    }

    function thumbsSliderTextHeight(textSlider){
        let $textSliderItems = textSlider.find('.js-thumb-slider-text-item');
        let maxHeight = 0;

        $textSliderItems.each(function(){
            if( $(this).innerHeight() >= maxHeight ){
                maxHeight = $(this).innerHeight();
            }
        });

        return maxHeight;
    }
}
